import {Injectable} from '@angular/core';
import {DocumentosJsonService} from '../../documentos-json.service';
import {Observable} from 'rxjs/Rx';
import 'rxjs/add/observable/forkJoin';

const getServices = [
  {nome: 'lojas', caption: 'Lojas', service: 'LojasService'},
  {nome: 'usuarios', caption: 'Usuários', service: 'UsuariosService'},
  {nome: 'categorias', caption: 'Categorias', service: 'CategoriassService'},
  {nome: 'skus', caption: 'SKUs', service: 'SkusService'},
  {nome: 'acao-perfil', caption: 'Perfis de Ação', service: 'AcaoPerfilService'},
  {nome: 'dimensoes', caption: 'Dimensões', service: 'DimensoesService'},
  {nome: 'subdimensoes', caption: 'Subdimensões', service: 'SubdimensoesService'},
  {nome: 'indicadores', caption: 'Indicadores', service: 'IndicadoresService'},
];

@Injectable()
export class GetServicesService {

  constructor(private _documentos: DocumentosJsonService) {
  }

  getLocalServices() {
    return Observable.of(getServices);
  }

  getGetServices() {
    return Observable.forkJoin([
      this._documentos.getDocumentosEmpresaTipo(0, 'lista'),
      this.getLocalServices()
    ]);
  }
}
